const TOKEN_KEY = "token";
const REMEMBERED_EMAIL_KEY = "adminRememberedEmail";
const REMEMBERED_PASSWORD_KEY = "adminRememberedPassword";

const hasBrowserStorage = () => typeof window !== "undefined";

/** Admin sessions persist in localStorage (remember me by default). */
export function getStoredToken() {
  if (!hasBrowserStorage()) return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token) {
  if (!hasBrowserStorage()) return;
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredToken() {
  if (!hasBrowserStorage()) return;
  localStorage.removeItem(TOKEN_KEY);
}

export function getRememberedCredentials() {
  if (!hasBrowserStorage()) {
    return { email: "", password: "" };
  }
  return {
    email: localStorage.getItem(REMEMBERED_EMAIL_KEY) || "",
    password: localStorage.getItem(REMEMBERED_PASSWORD_KEY) || "",
  };
}

export function setRememberedCredentials(email, password) {
  if (email) {
    localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
  } else {
    localStorage.removeItem(REMEMBERED_EMAIL_KEY);
  }
  if (password) {
    localStorage.setItem(REMEMBERED_PASSWORD_KEY, password);
  } else {
    localStorage.removeItem(REMEMBERED_PASSWORD_KEY);
  }
}

function getTokenPayload(token) {
  return JSON.parse(atob(token.split(".")[1]));
}

function isTokenExpired(payload) {
  if (!payload?.exp) return false;
  return payload.exp * 1000 <= Date.now();
}

/** Remove expired or malformed tokens from storage. */
export function purgeExpiredToken() {
  if (!hasBrowserStorage()) return;

  const token = getStoredToken();
  if (!token) return;

  try {
    if (isTokenExpired(getTokenPayload(token))) {
      clearStoredToken();
    }
  } catch {
    clearStoredToken();
  }
}

export function isStoredTokenValid() {
  if (!hasBrowserStorage()) return false;

  const token = getStoredToken();
  if (!token) return false;

  try {
    const payload = getTokenPayload(token);
    if (isTokenExpired(payload)) {
      clearStoredToken();
      return false;
    }
    return true;
  } catch {
    clearStoredToken();
    return false;
  }
}
